import React, {ReactElement, ReactNode} from 'react';
import {EventKind} from 'services/analytics';
import {useMount} from 'ui/effects/useMount';
import {useAnalytics} from 'ui/adapters/Analytics';

interface RegisterAfterMountProps {
  event: EventKind;
  children: ReactNode;
}

export const RegisterAfterMount = ({event, children}: RegisterAfterMountProps): ReactElement => {
  const register = useAnalytics(event);
  useMount(register);

  return <>{children}</>;
};
